import React, { useState } from 'react';
import './Dashboard.css';
import UserAnalytics from './UserAnalytics';
import ProductionAnalytics from './ProductionAnalytics';
import ProjectUserAnalytics from './ProjectUserAnalytics';
import CallsheetAnalytics from './CallsheetAnalytics';
import CrewAnalytics from './CrewAnalytics';
import CastAnalytics from './CastAnalytics';
import LocationAnalytics from './LocationAnalytics';
import ScriptAnalytics from './ScriptAnalytics';
import ScheduleAnalytics from './ScheduleAnalytics';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Dashboard = ({ onLogout, user }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('users');
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <div className="dashboard">
      {/* Hamburger menu for mobile */}
      <button className="menu-toggle" onClick={toggleSidebar}>
        ☰
      </button>

      {/* Sidebar */}
      <nav className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>My CallSheet App</h2>
          {/* Close button - only visible on mobile */}
          <button className="close-button" onClick={closeSidebar}>
            ×
          </button>
        </div>
        
        {/* User info and logout */}
        <div className="user-info">
          <Typography variant="body2" color="white" sx={{ opacity: 0.7 }}>
            Logged in as: {user?.email}
          </Typography>
          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <ul className="nav-links">
          <li>
            <a 
              href="#users" 
              onClick={() => setCurrentPage('users')}
              className={currentPage === 'users' ? 'active' : ''}
            >
              User Analytics
            </a>
          </li>
          <li>
            <a 
              href="#productions" 
              onClick={() => setCurrentPage('productions')}
              className={currentPage === 'productions' ? 'active' : ''}
            >
              Production Analytics
            </a>
          </li>
          <li>
            <a 
              href="#user-projects" 
              onClick={() => setCurrentPage('user-projects')}
              className={currentPage === 'user-projects' ? 'active' : ''}
            >
              User Projects
            </a>
          </li>
          <li>
            <a 
              href="#callsheets" 
              onClick={() => setCurrentPage('callsheets')}
              className={currentPage === 'callsheets' ? 'active' : ''}
            >
              Callsheet Analytics
            </a>
          </li>
          <li>
            <a 
              href="#crew" 
              onClick={() => setCurrentPage('crew')}
              className={currentPage === 'crew' ? 'active' : ''}
            >
              Crew Analytics
            </a>
          </li>
          <li>
            <a 
              href="#cast" 
              onClick={() => setCurrentPage('cast')}
              className={currentPage === 'cast' ? 'active' : ''}
            >
              Cast Analytics
            </a>
          </li>
          <li>
            <a 
              href="#locations" 
              onClick={() => setCurrentPage('locations')}
              className={currentPage === 'locations' ? 'active' : ''}
            >
              Location Analytics
            </a>
          </li>
          <li>
            <a 
              href="#scripts" 
              onClick={() => setCurrentPage('scripts')}
              className={currentPage === 'scripts' ? 'active' : ''}
            >
              Scripts Analytics
            </a>
          </li>
          <li>
            <a 
              href="#schedules" 
              onClick={() => setCurrentPage('schedules')}
              className={currentPage === 'schedules' ? 'active' : ''}
            >
              Schedule Analytics
            </a>
          </li>
        </ul>
      </nav>

      {/* Main content */}
      <main className="main-content">
        {currentPage === 'users' ? <UserAnalytics /> : currentPage === 'productions' ? <ProductionAnalytics /> : currentPage === 'user-projects' ? <ProjectUserAnalytics /> : currentPage === 'callsheets' ? <CallsheetAnalytics /> : currentPage === 'crew' ? <CrewAnalytics /> : currentPage === 'cast' ? <CastAnalytics /> : currentPage === 'locations' ? <LocationAnalytics /> : currentPage === 'scripts' ? <ScriptAnalytics /> : <ScheduleAnalytics />}
      </main>
    </div>
  );
};

export default Dashboard;